export default {
    allFaceStatus: 'All status',
    validFaceImage: 'Valid Face Image',
    inValidFaceImage: 'Invalid Face Image',
    searchText: 'Search by Employee name, ID',
    search: 'search',
    employeeId: 'Employee ID',
    employeeName: 'Employee Name',
    prefixThai: 'Thai Prefix',
    prefixEnglish: 'English Prefix',
    firstNameThai: 'Thai First name',
    firstNameEnglish: 'English First name',
    lastNameThai: 'Thai Last name',
    lastNameEnglish: 'English Last name',
    bureauAcronym: 'Bureau Acronym',
    positionAcronym: 'Position Acronym',
    status: 'status',
    line: 'Line',
    hasFace: 'Face Image',
    importFaceImage: 'Import face image',
    employeeManagement: 'Employee management',
    action: 'Action',
    editEmployeeProfile: 'Edit Employee profile',
    nameSurname: 'Name Surname',
    emailAddress: 'Email Address',
    organization: 'Organization',
    bureau: 'Bureau',
    position: 'Position',
    startDate: 'Start Date',
    resignDate: 'Resign Date',
    msgErrorImageSize: 'Image size can not be less than 25KB or more than 200KB',
    congratulation: 'Congratulation',
    updated: 'Updated',
    somethingWrong: 'Something Wrong!!',
    tryAgain: 'Please try again',
    lineRegisCode: 'LINE Registration Code',
    regisCode: 'Registration Code',
    instruction: 'Instruction',
    instructionOne: '1. Please click “Generate New code” (First time Only)',
    instructionTwo: '2. Copy code and Enter this code in Olaf Line OA',
    genNewQrWarning: 'If you’d like to unregister click “Generate New code” again, the user with previous code will be automatically cancel.',
    genNewCode: 'Generate New Code',
    setUpLineMenu: 'Set Up Line Menu',
    selectLineMenu: '- Select Line menu -',
    lineAndReportPermission: 'Line & Report Permission',
    selectPermission: '- Select Permission -',
    selectAll: 'Select All',
    deleteEmployee: 'Employee Delete',
    areYouSureToDeleteEmployee: 'Are you sure you want to delete Employee',
    employeeIsDeleted: 'Employee is Deleted',
    exportEployee: 'Export Form Excel',
    empRequiredField: 'This field is required',
    empExceededField: 'This field is exceeded 255 characters',
    emailIsExceeded255Characters: 'This field is exceeded 255 characters',
    invalidEMailFormat: 'Invalid e-mail format',
    profile: 'Profile'
}
